// Node modules
import { nanoid } from 'nanoid';

// Components
import Button from '@/components/global-components/Button';
import Reason from './Reason';

// Themes
import theme from '@/themes/index';

const Reasons = ({
  content: {
    title,
    secondaryTitle,
    button, 
    reasonsList,
  }, 
}) => (
  <>
    <div className='container'>
      <h4>{title}</h4>
      <div className='reasons-container'>
        {reasonsList.map(item => (
          <Reason key={nanoid()} content={item.reason}></Reason>
        ))}
      </div>
      <div className='button-container'>
        <h6>{secondaryTitle}</h6>
        <Button
          text={button.title}
          href={button.url}
          className={button.style.toLowerCase()}
          target={button.openInAnotherPage ? '_blank' : '_self'}
          width='9.125rem'
          styles={{
            margin: 'auto', fontSize: '0.875rem', textAlign: 'center', maxWidth: '10rem', width: '10rem', 
          }}
        />
      </div>
    </div>
    <style jsx>{`
      .container {
        height: auto;
        display: flex;
        flex-direction: column;
      }
      .container h4 {
        text-align: center;
        font-family: ${theme.fontFamilies.montserratSemiBold};
      }
      .container .button-container {
        display: flex;
        flex-direction: column;
        padding-top: 5rem;
        gap: 1rem;
      }
      .container .button-container h6 {
        text-align: center;
        font-family: ${theme.fontFamilies.montserratBold};
        margin-block-start:0;
        margin-block-end:0;
      }
      .container .reasons-container {
        flex-direction: row;
        justify-content: center;
        height: 100%;
        display: flex;
        flex-direction: column-reverse;
        gap: 1rem;
        padding: 0 2rem;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
        .container .reasons-container {
          display: flex;
          width: 100%;
          gap: 4rem;
          flex-direction: row;
          padding: 0;
          align-items: flex-start;
        }
      }
    `}</style>
  </>
);

export default Reasons;
